export default __webpack_public_path__ + "static/media/PREMIOS IMPULSO SUME BY SAINT GOBAIN 2024 - MTY042 - AGREGAR FOTO HUMEDAL.302f505a.pdf";